import { useState } from 'react';
import { features, featureGroups } from '@/mocks/home';

export default function FeatureSection() {
  const [active, setActive] = useState('all');
  const visible = active === 'all' ? features : features.filter((f) => f.group === active);

  return (
    <section id="features" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-accent-600">
              Features
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              字幕与播放能力一览
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              这些是同类平台中较常见、也与「在线字幕」体验最相关的功能。不同版本之间可能存在差异，
              以下仅作了解与对照之用。
            </p>
          </div>

          <div className="flex flex-wrap gap-2 rounded-full border border-secondary-200 bg-secondary-50 p-1">
            {featureGroups.map((g) => (
              <button
                key={g.id}
                type="button"
                onClick={() => setActive(g.id)}
                className={`whitespace-nowrap rounded-full px-3.5 py-2 text-xs md:text-sm font-medium transition-colors cursor-pointer ${
                  active === g.id
                    ? 'bg-secondary-500 text-background-50 dark:text-foreground-950'
                    : 'text-secondary-800 hover:bg-secondary-100'
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {visible.map((f) => (
            <article
              key={f.title}
              className="rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}